import React from 'react';
import PropTypes from 'prop-types';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import { CRQ_STATUSES } from 'AppSrc/core/crq/crq-statuses';
import { ChangeCoordinator } from './change-coordinator';
import 'AppSrc/core/style/components/view-crq-screen/change-assignee-modal.css';

const editingTypeMap = {
  [CRQ_STATUSES.coordinator]: ChangeCoordinator,
  // peerReview uses ChangeCoordinator as the logic is identical except for which fields form fields are changed
  [CRQ_STATUSES.peerReview]: ChangeCoordinator,
};

const getAssigneeChangeComponent = (editingType) => {

  const ChangeComponent = editingTypeMap[editingType];

  if (!ChangeComponent) {
    console.error(`Cannot find ChangeComponent for editingType: ${editingType} in getAssigneeChangeComponent`);
    return null;
  }
  return ChangeComponent;
};


class ChangeAssigneeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitSuccess: null,
    };
    this.setSubmitSuccess = this.setSubmitSuccess.bind(this);
  }

  setSubmitSuccess(bool) {
    this.setState({
      submitSuccess: bool,
    });
  }


  render() {
    const {
      network,
      crqId,
      slaType,
      isIcmCrq,
      closeChangeAssigneeModal,
      editingName,
      editingType,
    } = this.props;
    const {
      submitSuccess,
    } = this.state;
    const ChangeComponent = getAssigneeChangeComponent(editingType);

    // if we don't have a ChangeComponent it's safest to show nothing
    if (!ChangeComponent) {
      return null;
    }


    return (
      <ModalPortal>
        <div
          className="change-assignee-modal"
        >
          <div className="change-assignee-shadow" />
          <div className="change-assignee-inner">
            <ChangeComponent
              network={network}
              crqId={crqId}
              slaType={slaType}
              isIcmCrq={isIcmCrq}
              closeChangeAssigneeModal={closeChangeAssigneeModal}
              setSubmitSuccess={this.setSubmitSuccess}
              submitSuccess={submitSuccess}
              initialName={editingName}
              editingType={editingType}
            />
          </div>
        </div>
      </ModalPortal>
    );
  }
}


ChangeAssigneeModal.propTypes = {
  network: PropTypes.string,
  crqId: PropTypes.string,
  closeChangeAssigneeModal: PropTypes.func,
  editingName: PropTypes.string,
  editingType: PropTypes.string, // it relates to a status. Statuses are strings
  slaType: PropTypes.string,
  isIcmCrq: PropTypes.bool,
};




export { ChangeAssigneeModal };




